// const defaultRender = (value) => (value  ? value : '--');

// const columns = [
//     {
//         title: 'Name',
//         dataIndex: 'name',
//         render: defaultRender,
//         sorter: (a, b) => a?.name?.localeCompare(b?.name),
//     },
//     {
//         title: 'Email',
//         dataIndex: 'email',
//         render: defaultRender,
//         sorter: (a, b) => a?.email?.localeCompare(b?.email),
//     },
//     {
//         title: 'Mobile No',
//         dataIndex: 'phoneNo',
//         render: defaultRender,
//         sorter: (a, b) => a?.phoneNo?.localeCompare(b?.phoneNo),
//     },
//     {
//         title: 'Referral Code',
//         dataIndex: 'referralCode',
//         render: defaultRender,
//         sorter: (a, b) => a?.referralCode?.localeCompare(b?.referralCode),
//     },
//     {
//         title: 'Affiliate Code',
//         dataIndex: 'affiliateCode',
//         render: defaultRender,
//         sorter: (a, b) => a?.affiliateCode?.localeCompare(b?.affiliateCode),
//     },
//     {
//         title: 'Registered Date',
//         dataIndex: 'registeredDate',
//         render: defaultRender,
//         sorter: (a, b) => a?.registeredDate - b?.registeredDate,
//     },
//     {
//         title: 'Actions',
//         dataIndex: 'actions',
//         render: defaultRender,
//     },
// ];

// export default columns;


const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        render: defaultRender,
    },
    {
        title: 'Email',
        dataIndex: 'email',
        render: defaultRender,
        sorter: true,
    },
    {
        title: 'Mobile No',
        dataIndex: 'phoneNo',
        render: defaultRender,
        sorter:true
    },
    {
        title: 'Level',
        dataIndex: 'level',
        render: defaultRender,
        sorter: true,
    },
    {
        title: 'FTD',
        dataIndex: 'isFTD',
        render: defaultRender,
    },
    {
        title: 'Referral Code',
        dataIndex: 'referralCode',
        render: defaultRender,
    },
    {
        title: 'Affiliate Code',
        dataIndex: 'affiliateCode',
        render: defaultRender,
    },
    {
        title: 'User Type',
        dataIndex: 'userType',
        render: defaultRender,
    },
    {
        title: 'Registered Date',
        dataIndex: 'createdDate',
        render: defaultRender,
        sorter: true,
    },
    {
        title: 'Actions',
        dataIndex: 'actions',
        render: defaultRender,
    },
];

export default columns;